<template>
  <v-badge>
    <slot />
  </v-badge>
</template>

<style scoped>
.v-badge {
  display: inherit;
}
</style>